import { connect } from 'react-redux'
import { GartenIntegration } from '@components/account/accountSections'
import { Account } from '@types'

interface State {
  account: Account
}

const mapStateToProps = (state: State) => ({
  accountId: state.account.id,
})

export default connect(mapStateToProps)(GartenIntegration)
